import React from 'react'
import BookingConfirmCard from '../Components/BookingConfirmCard'

const Payment_page = () => {
  return (
    <div className='mt-28 mb-8'>
      <BookingConfirmCard />
    </div>
  )
}

export default Payment_page